export type InputSize = 'md' | 'lg';

export const sizeMap: Record<InputSize, string> = {
	lg: 'text-2xl p-2',
	md: 'text-base px-2 pt-[7px] pb-[5px]',
};

export const getSizeClass = (size: InputSize) => sizeMap[size];
